module.exports = __webpack_public_path__ + "img/logout.cdea770f.png";